var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEquipmentEvolution = function SvgEquipmentEvolution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 407,
    height: 121,
    viewBox: "0 0 407 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.279 80.741H6.247M25.758 87.637h16.064l-1.988-12.98c-.162-1.137-1.136-1.948-2.271-1.948H26.894c-.649 0-1.136.527-1.136 1.136v13.792ZM9.654 80.741l6.896 6.896M33.79 96.845a3.445 3.445 0 0 1-3.448-3.448 3.445 3.445 0 0 1 3.448-3.448 3.445 3.445 0 0 1 3.448 3.448 3.445 3.445 0 0 1-3.448 3.448ZM9.654 96.845a3.445 3.445 0 0 1-3.448-3.448 3.445 3.445 0 0 1 3.448-3.448 3.445 3.445 0 0 1 3.448 3.448 3.445 3.445 0 0 1-3.448 3.448Z",
    stroke: "#2C112D",
    strokeWidth: 1.533,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.654 72.709v8.032c0 .649.528 1.135 1.136 1.135h6.896M30.342 93.397h-17.24M6.206 93.397H2.758v-4.584l4.584-1.135h35.656v5.76h-5.76",
    stroke: "#2C112D",
    strokeWidth: 1.533,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.429 96.524c-2.477 0-4.508-2.032-4.508-4.508s2.031-4.508 4.508-4.508c2.476 0 4.508 2.032 4.508 4.508a4.485 4.485 0 0 1-4.508 4.508ZM63.143 96.524c-2.476 0-4.508-2.032-4.508-4.508s2.032-4.508 4.508-4.508 4.508 2.032 4.508 4.508-2.032 4.508-4.508 4.508ZM105.556 78.429v12.635c0 1.016.825 1.777 1.777 1.777h14.477",
    stroke: "#2C112D",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.937 51.38V83.89H91.079l-3.619 9.016H73.048l-3.556-9.016H58.635l.952-3.683S66.762 76.651 74 76.651h9.905M101.936 78.429h3.62",
    stroke: "#2C112D",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.762 83.89 93.175 71c-.127-.888-.89-1.587-1.778-1.587h-5.651a1.775 1.775 0 0 0-1.778 1.778v12.635M82.127 83.889h12.635M82.127 83.889v9.016",
    stroke: "#2C112D",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.228 96.603c-3.646 0-6.637-2.992-6.637-6.637 0-3.646 2.991-6.637 6.637-6.637 3.645 0 6.636 2.991 6.636 6.637-.093 3.739-2.991 6.637-6.636 6.637ZM141.61 96.603c-3.645 0-6.636-2.992-6.636-6.637 0-3.646 2.991-6.637 6.636-6.637 3.646 0 6.637 2.991 6.637 6.637 0 3.739-2.991 6.637-6.637 6.637Z",
    stroke: "#2C112D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.153 78.095H187.88l-5.328 15.89h-26.453l-5.328-15.89h-18.508M206.481 51.642h18.508v7.945h-18.508v-7.945ZM215.735 43.696v7.946",
    stroke: "#2C112D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.263 83.423H174.7l-7.197-11.965c-.468-.841-1.309-1.309-2.244-1.309h-3.832a2.612 2.612 0 0 0-2.617 2.618v10.562h-5.329M174.7 83.423h-15.89M182.646 83.423l-13.274-29.164M137.591 49.024l79.453-13.273 2.617 5.328-79.453 18.508-2.617-10.563ZM144.414 58.652l6.45 19.443M290.019 96.704a6.216 6.216 0 0 1-6.222-6.22 6.216 6.216 0 0 1 6.222-6.222 6.216 6.216 0 0 1 6.221 6.221c-.073 3.44-2.855 6.221-6.221 6.221ZM240.321 96.704a6.216 6.216 0 0 1-6.221-6.22 6.216 6.216 0 0 1 6.221-6.222 6.216 6.216 0 0 1 6.221 6.221 6.216 6.216 0 0 1-6.221 6.221Z",
    stroke: "#2C112D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M232.05 80.09h14.492l6.222 10.32h24.812l6.221-10.32h16.542M232.05 80.09l1.684-6.734c.219-.951 1.024-1.537 1.976-1.537h14.931l2.049 8.271h31.107",
    stroke: "#2C112D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m275.526 80.09-18.664-18.664h-20.713M300.339 32.515v60.017",
    stroke: "#2C112D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M240.321 61.499h6.221v10.32h-6.221V61.5ZM304.511 59.45V38.736M252.69 61.498l-3.659-10.978c-.293-.879-1.098-1.391-1.976-1.391h-4.685a2.046 2.046 0 0 0-2.049 2.05v10.32M300.339 55.277 252.69 80.09M362.198 84.721v-54.07h-30.593v54.07h-9.407V21.163h49.407v63.558h-9.407ZM333.977 16.5h25.93M338.639 54.128h16.523M326.86 84.72V96.5M366.942 84.72V96.5",
    stroke: "#2C112D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M350.419 49.465v-4.744h-7.035v4.744",
    stroke: "#2C112D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M352.791 30.651v14.152h-11.78V30.65",
    stroke: "#2C112D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgEquipmentEvolution;